"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createPagePosition = function (position, page) {
    if (page === void 0) { page = 0; }
    return {
        page: page,
        position: position
    };
};
exports.computePages = function (limit, offset, total, reservedPageCount) {
    var minPage = 1;
    var maxPage = Math.floor(total / limit) + (total % limit === 0 ? 0 : 1);
    var currentPage = Math.floor(offset / limit) + 1;
    var previousPage = currentPage <= minPage ? 0 : currentPage - 1;
    var nextPage = currentPage >= maxPage ? 0 : currentPage + 1;
    var pages = [];
    pages.push(createPagePosition(3, previousPage));
    var lowInnerReservedPageCount = Math.max(reservedPageCount + currentPage - maxPage, 0);
    var lowInnerEllipsisPage = currentPage - reservedPageCount - lowInnerReservedPageCount - 1;
    var lowOuterEllipsisPage = minPage + reservedPageCount;
    for (var i = minPage; i < currentPage; i++) {
        if (i < lowOuterEllipsisPage) {
            pages.push(createPagePosition(5, i));
        }
        else {
            pages.push(i === lowOuterEllipsisPage && i < lowInnerEllipsisPage
                ? createPagePosition(1)
                : createPagePosition(5, i));
            for (var j = Math.max(i, lowInnerEllipsisPage) + 1; j < currentPage; j++) {
                pages.push(createPagePosition(5, j));
            }
            break;
        }
    }
    pages.push(createPagePosition(0, currentPage));
    var highInnerReservedPageCount = Math.max(reservedPageCount - currentPage + minPage, 0);
    var highInnerEllipsisPage = currentPage + reservedPageCount + highInnerReservedPageCount + 1;
    var highOuterEllipsisPage = maxPage - reservedPageCount;
    for (var i = currentPage + 1; i <= maxPage; i++) {
        if (i < highInnerEllipsisPage) {
            pages.push(createPagePosition(5, i));
        }
        else {
            pages.push(i === highInnerEllipsisPage && i < highOuterEllipsisPage
                ? createPagePosition(2)
                : createPagePosition(5, i));
            for (var j = Math.max(i, highOuterEllipsisPage) + 1; j <= maxPage; j++) {
                pages.push(createPagePosition(5, j));
            }
            break;
        }
    }
    pages.push(createPagePosition(4, nextPage));
    return pages;
};
exports.getOffset = function (page, limit) {
    var offset = (page - 1) * limit;
    return offset < 0 ? 0 : offset;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-flat-pagination/lib/core.js
// module id = 536
// module chunks = 0